import axios from '@/api/axios'
import server from '@/config/server.js'
import store from '@/store';
/**
 * 防抖函数
 * @param {防抖方法} fn 
 * @param {防抖时间} delay 
 */
const debounceFn = function(fn, delay = 1000, params) {
  clearTimeout(fn.id);
  fn.id = setTimeout(() => fn(params), delay);
}

const downloadBlob = function(blob, name){
  let a= document.createElement("a");
  a.style.display = "none"
  a.download = name
  a.href = URL.createObjectURL(blob)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
} 

let uploadChunk = async function(blob, fileName, fileType){ // 初始化上传任务
  return new Promise((resolve) => {
    store.commit("loading/uploadingProgress", 0)
    store.commit("loading/uploading", true)
    let identifier = new Date().getTime()
    let newFileName =  `${fileName}-${identifier}.${fileType}`
    axios.post(server.uploadChunkInit, {
      identifier, fileName: newFileName
    }).then(async res => {
      if (res.data.success) {
        resolve(await uploadChunkRequest(blob, newFileName, identifier))
      } else {
        // store.commit("snack/error", res.data.msg || "上传失败！")
        console.log(res.data.msg || "上传失败！")
        store.commit("loading/uploading", false)
        resolve()
      }
    }).catch(() => {
      store.commit("loading/uploading", false)
      resolve()
    })
  })
}

let uploadChunkRequest = function(blob, fileName, identifier) {
  return new Promise((resolve) => {
    const chunkSize = 1024 * 1024; // 每次上传的大小
    let remainder = blob.size % chunkSize // 分块余数
    let totalChunk = Math.floor(blob.size / chunkSize)
    let totalChunks = remainder > 0 ? totalChunk + 1 : totalChunk
    let uploadedChunk = 0 // 已上传完成的块
    for (let i = 1; i <= totalChunks; i++) {
      let fd = new FormData();
      let xhr = new XMLHttpRequest();
      fd.append('chunkNumber', i);
      fd.append('chunkSize', chunkSize);
      fd.append('currentChunkSize', totalChunks === i ? remainder : chunkSize);
      fd.append('totalSize', blob.size);
      fd.append('identifier', identifier);
      fd.append('filename', fileName);
      fd.append('totalChunks', totalChunks);
      // 根据长度截取每次需要上传的数据
      fd.append('file', blob.slice((i - 1) * chunkSize, i * chunkSize));
      xhr.open('POST', server.uploadChunk, true);
      xhr.setRequestHeader("Authorization",localStorage.getItem("tokenn"));
      xhr.onreadystatechange = () => { // 上传成功回调
        if (xhr.readyState === 4 && xhr.status === 200 && xhr.responseText) {
          uploadedChunk++
          if (totalChunks === uploadedChunk) {
            console.log('上传完成')
            store.commit("loading/uploadingProgress", 1)
            store.commit("loading/uploading", false)
            let file = JSON.parse(xhr.responseText) // 返回结果
            resolve(file.path)
          } else {
            store.commit("loading/uploadingProgress", uploadedChunk * chunkSize / blob.size)
          }
        }
      }
      xhr.onerror = (evt) => { // 上传失败回调
        console.log(JSON.stringify(evt.target))
        store.commit("loading/uploading", false)
        resolve()
      }
      xhr.send(fd);
    }
  })
}

export {
  debounceFn,
  downloadBlob,
  uploadChunk
}